export default __webpack_public_path__ + "static/media/CNo.60-0.84542490.jpg";